import type { KindSpec } from "./types";
import type { AddableKind } from "../lib/words";
import { dataFieldSpec, dataGroupSpec, pickListSpec } from "./data";
import { documentKindSpec, documentLinkSpec, linkSpec } from "./documents";
import { capabilitySpec, componentKindSpec, componentSpec, familySpec, itemSpec, subFamilySpec } from "./structure";

/** The form of each kind of element a person can add by hand. */
export const KIND_SPECS: Record<AddableKind, KindSpec> = {
  item: itemSpec,
  family: familySpec,
  sub_family: subFamilySpec,
  component_kind: componentKindSpec,
  component: componentSpec,
  capability: capabilitySpec,
  data_field: dataFieldSpec,
  data_group: dataGroupSpec,
  pick_list: pickListSpec,
  document_kind: documentKindSpec,
  document_link: documentLinkSpec,
  link: linkSpec,
};

export { type KindSpec } from "./types";
